import React, { useMemo } from 'react';
import { Badge } from 'react-bootstrap';

const TotalFooter = ({ contas }) => {
  const soma = useMemo(
    () => (contas || []).reduce((s, c) => s + (Number(c.percentual) || 0), 0),
    [contas]
  );

  const variant = soma >= 99.9999 && soma <= 100.0001 ? 'success' : soma > 100.0001 ? 'danger' : 'warning';
  const label = soma >= 99.9999 && soma <= 100.0001 ? '100% — Completo' : soma > 100 ? `${soma.toFixed(2)}% — Excede 100%` : `${soma.toFixed(2)}% — Incompleto`;

  return (
    <div className="d-flex justify-content-end align-items-center p-2" style={{ borderTop: '1px solid #dee2e6' }}>
      <span className="mr-2 small text-muted">Total:</span>
      <Badge variant={variant} style={{ fontSize: '0.85rem', padding: '5px 10px' }}>
        {label}
      </Badge>
    </div>
  );
};

export default TotalFooter;
